import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Grainient from '../components/Grainient';
import surgeLogo from '../Images/SURGE_LOGO.svg';
import './Landing.css';

function Landing() {
  const navigate = useNavigate();
  const [isNavigating, setIsNavigating] = useState(false);
  const navigationTimeoutRef = useRef(null);

  useEffect(() => () => {
    if (navigationTimeoutRef.current) clearTimeout(navigationTimeoutRef.current);
  }, []);

  const handlePlayClick = () => {
    if (isNavigating) return;
    setIsNavigating(true);
    navigationTimeoutRef.current = setTimeout(() => {
      navigate('/game');
    }, 500);
  };

  return (
    <main className="landing landing--table">
      <Grainient
        className="landing__grainient"
        color3="#1b5e20"
        gamma={1.15}
      />
      <section className="landing-hero">
        <img src={surgeLogo} alt="SURGE" className="landing-hero__logo" />
        <button
          type="button"
          className={`landing__cta type1${isNavigating ? ' landing__cta--loading' : ''}`}
          onClick={handlePlayClick}
          disabled={isNavigating}
        >
          <span className="btn-txt">Let's play</span>
        </button>
      </section>
    </main>
  );
}

export default Landing;